
import { Route, Routes } from "react-router-dom";
import AnnouncementCreateScreen from "screens/App/CRM/Announcement/AnnouncementCreateScreen";
import AnnouncementDetailScreen from "screens/App/CRM/Announcement/AnnouncementDetailScreen";
import AnnouncementEditScreen from "screens/App/CRM/Announcement/AnnouncementEditScreen";
import AnnouncementListScreen from "screens/App/CRM/Announcement/AnnouncementListScreen";
import { NotFoundScreen } from "screens/NotFoundScreen";

const AnnouncementRouter = () => {
  return (
    <Routes>
      <Route path="create" element={<AnnouncementCreateScreen />} />
      <Route path=":id/detail" element={<AnnouncementDetailScreen />} />
      <Route path=":id/edit" element={<AnnouncementEditScreen />} />
      <Route path="list" element={<AnnouncementListScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default AnnouncementRouter;
